(function($) {

	$(document).ready(function() {
		var $body = $('body');
		if ($body.length < 1) {
			return;
		}

		if ($body.hasClass('elementor-editor-active')) {
			return;
		} else {
			$('body a:not([href*="#"], [href=""], [target*="_BLANK"], [target*="_blank"], [href*="javascript"])').each( function() {
				$( this ).addClass('animsition-link');
				$( this ).attr('data-animsition-out-class', 'fade-out');
			});
			$(".animsition").animsition({
				inClass: 'fade-in',
				outClass: 'fade-out',
				inDuration: 1000,
				outDuration: 500,
				linkElement: '.animsition-link',
				// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
				loading: true,
				loadingParentElement: 'body', //animsition wrapper element
				loadingClass: 'animsition-loading',
				loadingInner: '', // e.g '<img src="loading.svg" />'
				timeout: false,
				timeoutCountdown: 5000,
				onLoadEvent: true,
				browser: [ 'animation-duration', '-webkit-animation-duration'],
				// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
				// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
				overlay : false,
				overlayClass : 'animsition-overlay-slide',
				overlayParentElement : 'body',
				transition: function(url){ window.location.href = url; }
			});
		}
	});

})(jQuery);
